module.exports = __webpack_public_path__ + "fr_CH-download-722618.webp";